import { Flex, Text, VStack } from "@chakra-ui/react"
import { useTranslation } from 'react-i18next'

type ScheduleType = {
    day: string;
    time: string;
  }
  
  type classDisplayType = {
    title: string;
    time: ScheduleType[];
  }
  
  const Schedule = ({day, time}: ScheduleType) => {
    const { t } = useTranslation()

    return (
      <Flex
        justify="space-between"
        align="center"
        gap={6}
        width="100%"
      >
        <Text fontSize={{ base: 'md', md: 'lg' }}>{t(day)}</Text>
        <Text
          fontSize={{ base: 'md', md: 'lg' }}
          whiteSpace="nowrap"
          textAlign="right"
        >
          {time}
        </Text>
      </Flex>
    )
  }
  
  
  const ClassDisplay = ({title, time}:classDisplayType) => {
    const { t } = useTranslation()
    return (
  
        <VStack
          align="stretch"
          width="100%"
          spacing={3}
          borderLeft="5px solid"
          borderColor="pink.200"
          borderRadius="12px"
          bg="rgba(255,255,255,0.82)"
          boxShadow="0 4px 16px rgba(75, 55, 90, 0.08)"
          padding={{ base: '18px 20px', md: '20px 28px' }}
          _hover={
            {
              bg: 'pink.50',
            }
          }
          >
          <Text
            fontSize={{ base: 'xl', md: '2xl' }}
            fontWeight="bold"
            color="purple.900"
            textAlign="left"
          >{t(title)}</Text>
          <VStack align="stretch" spacing={2}>
            {time.map((schedule, index) => (
              <Schedule
                day={schedule.day}
                time={schedule.time}
                key={index}
              />
            ))}
          </VStack>
        </VStack>
    )
  }

  export default ClassDisplay;
